import {
    useEffect,
    useState,
    type FC
} from "react";
import {
    TextInput as NativeTextInput,
    type FocusEvent,
    type BlurEvent
} from "react-native";
import type IInputGroupInputProps from "./type";
import stylesheet from "./stylesheet";
import {
    useInputGroupContext
} from "../../context";
import {
    getInputGroupDescription
} from "../../stylesheet";

const InputGroupInput: FC<IInputGroupInputProps> = ({
    onChangeText: onChangeTextProp,
    onFocus: onFocusProp,
    onBlur: onBlurProp,
    value: valueProp,
    defaultValue,
    style,
    ...props
}) => {
    const {
        inputAccessibilityProps,
        placeholderTextColor,
        onInputLengthChange,
        onInputFocus,
        onInputBlur,
        inputStyle,
        isDisabled,
        isReadOnly,
        isLoading,
        textHints,
        inputRef
    } = useInputGroupContext();

    const [
        value,
        setValue
    ] = useState(defaultValue ?? "");

    const currentValue = valueProp ?? value;

    useEffect(() => {
        onInputLengthChange(currentValue.length);
    }, [
        currentValue
    ]);

    const onChangeText = (text: string) => {
        const inputValue = text.replace(/\n/g, "");

        setValue(inputValue);

        if(onChangeTextProp) {
            onChangeTextProp(inputValue);
        }
    };

    const onFocus = (event: FocusEvent) => {
        onInputFocus();

        if(onFocusProp) {
            onFocusProp(event);
        }
    };

    const onBlur = (event: BlurEvent) => {
        onInputBlur();

        if(onBlurProp) {
            onBlurProp(event);
        }
    };

    return <NativeTextInput
        {...inputAccessibilityProps}
        {...props}
        {...getInputGroupDescription({
            accessibilityProps: inputAccessibilityProps,
            describedBy: props["aria-describedby"],
            hint: props.accessibilityHint,
            textHints
        })}
        aria-busy={isLoading || inputAccessibilityProps["aria-busy"]}
        placeholderTextColor={placeholderTextColor}
        editable={!isDisabled && !isReadOnly}
        underlineColorAndroid="transparent"
        onChangeText={onChangeText}
        style={[
            style,
            stylesheet.input,
            inputStyle
        ]}
        value={currentValue}
        multiline={false}
        onFocus={onFocus}
        onBlur={onBlur}
        ref={inputRef}
    />;
};
export default InputGroupInput;
